import React, { useState } from 'react';
import SLASettings from './tabs/SLASettings';
import AttendanceSettings from './tabs/AttendanceSettings';
import TeamPermissions from './tabs/TeamPermissions';
import WorkflowSettings from './tabs/WorkflowSettings';
import NotificationSettings from './tabs/NotificationSettings';
import EmailTemplates from './EmailTemplates';
import DataImport from './tabs/DataImport';
import UsersPage from '../Users';

const TABS = [
  { key: 'users',          label: 'User Management',    icon: '👤' },
  { key: 'team',           label: 'Team & Permissions',  icon: '👥' },
  { key: 'workflow',       label: 'Ticket Workflow',     icon: '⚙️'  },
  { key: 'sla',            label: 'SLA',                icon: '📋' },
  { key: 'attendance',     label: 'Attendance',          icon: '📅' },
  { key: 'notifications',  label: 'Notifications',       icon: '🔔' },
  { key: 'email_templates',label: 'Email Templates',     icon: '✉️'  },
  { key: 'data_import',    label: 'Data Import',         icon: '📥' },
];

export default function Settings() {
  const [activeTab, setActiveTab] = useState('sla');

  return (
    <div className="p-6 space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-brand-500">Settings</h1>
        <p className="text-gray-400 text-sm mt-0.5">System configuration — Admin only</p>
      </div>

      <div className="flex flex-wrap gap-1 border-b border-brand-100">
        {TABS.map(t => (
          <button
            key={t.key}
            onClick={() => setActiveTab(t.key)}
            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-semibold whitespace-nowrap border-b-2 transition-colors ${
              activeTab === t.key
                ? 'border-magenta-500 text-magenta-600'
                : 'border-transparent text-gray-400 hover:text-brand-500'
            }`}
          >
            <span>{t.icon}</span>
            {t.label}
          </button>
        ))}
      </div>

      <div>
        {activeTab === 'users'           && <UsersPage />}
        {activeTab === 'team'            && <TeamPermissions />}
        {activeTab === 'workflow'        && <WorkflowSettings />}
        {activeTab === 'sla'             && <SLASettings />}
        {activeTab === 'attendance'      && <AttendanceSettings />}
        {activeTab === 'notifications'   && <NotificationSettings />}
        {activeTab === 'email_templates' && <EmailTemplates />}
        {activeTab === 'data_import'    && <DataImport />}
      </div>
    </div>
  );
}
